import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import image from "_assets/images/PRM-Logo-PNG/test-flight-appstore.png";
import Image from 'react-bootstrap/Image';

const TestFlightAppstore = () => {
    return (
        <>
          <Container>
            <Row>
              <div>
              <Image
                src={image}
                height={300}
              />
              </div>
            </Row>
          </Container>      
        </>
    );
};

export default TestFlightAppstore;
